import { Divider, Grid, Typography } from '@material-ui/core';
import { ageInYears, formatLocalDate } from '../../core/date-time';
import { truncateSpan } from '../../core/format';



import { FieldValue } from '../../components/common/presentation';
import { Visit, getPrimaryInsuranceLabel } from '../domain';

function VField({ label, value, style = undefined, truncate = NaN }) {
    return (
      <Grid container direction="column" style={style}>
        <Grid item>
          <Typography style={{ whiteSpace: 'nowrap' }} variant="body2" color="textSecondary">
            {label}
          </Typography>
        </Grid>
        <Grid item>
          <Typography color="textPrimary">{isNaN(truncate) ? value : truncateSpan(value, truncate + 'px')}</Typography>
        </Grid>
      </Grid>
    );
  }

export function AlertDemographics(visit: Visit) {
    const { firstName, lastName, birthDate, gender } = visit.patient;
    const { accountNumber, mrn, registrationDate, dischargeDate, insurances } = visit;
    const ins = getPrimaryInsuranceLabel(insurances || []);
  
    const divider = (
      <div style={{ padding: '12px 0px 12px 0px' }}>
        <Divider orientation="horizontal" style={{ width: '312px' }} />
      </div>
    );
  
  
    return (
      <div style={{ width: '100%', padding: '12px 24px 0 24px' }} >
        <FieldValue label="Patient" value={lastName + ', ' + firstName} />
        <Grid container style={{ paddingTop: 12, flexWrap: 'nowrap', width: '100%' }} direction="row" spacing={2} justify="space-between" alignItems="center">
          <FieldValue label="Account" value={accountNumber} />
          <VField label="MRN" value={mrn} truncate={67} />
          <FieldValue label="Date of Birth" value={birthDate ? formatLocalDate(birthDate) : ''} />
          <FieldValue label="Age" value={birthDate ? ageInYears(birthDate) : ''} />
          <FieldValue label="Gen." value={(gender || '').charAt(0)} />
        </Grid>
        <Grid container style={{ paddingTop: 12, paddingLeft: 8, flexWrap: 'nowrap' }} direction="row" spacing={2} justify="center" alignItems="center">
          <VField label="Registration Date" value={formatLocalDate(registrationDate)} />
          {dischargeDate && <VField label="Discharge Date" value={formatLocalDate(dischargeDate)} />}
        </Grid>
        <VField label="Insurance" value={ins} style={{ paddingTop: 24 }} />
        <Grid item style={{ height: 12 }}/>
      </div>
    );
  }